<template>
  <div v-if="item.attributes.uploading" class="content-loading-container item-container justify-content-center d-flex flex-column" data-testid="loading-gif">
    <img src="@img/cloud-loader.gif">
    <div v-if="showUploadingText" class="text-center loading-text" v-cloak>
      <h4>{{header}}</h4>
      <p class="text-muted">This may take several minutes. If you have any questions please email us at <a href="mailto:support@getcloudapp.com" class="support-link" data-testid="support-email-link">support@getcloudapp.com &rarr;</a></p>
    </div>
    <feedback-widget
      :show="showFeedback"
      @submit="sendFeedback">
      How would you rate this experience?
    </feedback-widget>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import track from '@/src/tracking';
import UAParser from "ua-parser-js";
import FeedbackWidget from "@cmp/shared/feedback_widget.vue";

export default {
  components: { FeedbackWidget },
  data: function(){
    return {
      showUploadingText: false,
      enableFeedback: false
    }
  },
  created: function(){
    const vm = this;
    setTimeout(function(){ vm.showUploadingText = true }, 10000)
    setTimeout(function(){ vm.enableFeedback = true }, 2 * 60 * 1000)
  },
  computed: {
    ...mapState(['item', 'itemOrganization', 'user']),
    header: function(){
      return this.item.attributes.action_type == 'gt' ? 'Processing gif...' : 'Content is being uploaded.'
    },
    showFeedback: function(){
      return this.enableFeedback && this.item.attributes.item_type == 'video'
    },
    isOwner: function () {
      return (this.item.relationships?.user?.data?.id === this.user?.id) === true;
    }
  },
  methods: {
    sendFeedback: function(feedback){
      const browser = new UAParser(navigator.userAgent).getBrowser();

      let event = {
        score: feedback.score,
        comment: feedback.comment,
        plan: this.itemOrganization.attributes.plan_name,
        email: this.user.attributes.email,
        is_owner: this.isOwner,
        anonymous: !this.user.id,
        hashid: this.item.id,
        source_app: this.item.attributes.client_version,
        user_agent: `${browser.name} ${browser.version}`,
        source: 'video_uploading'
      }

      track('video_review', event)
    }
  }
}
</script>

<style scoped lang="scss">
  .loading-text { margin-bottom: 1rem; }
</style>